import cloneDeep from 'lodash/cloneDeep';

import { handleActions } from 'redux-actions';
import axios from 'axios';
import endpoints from '../../config/endpoints';
import intl from '../shared/intl';
import checkPermissions from '../shared/check-permissions';
import { actions as rootActions } from '../root';

// actions types
const FETCH_DATA_SUCCESS = 'landing-reports/fetch-data-success';
const TOGGLE_PROGRESS_BAR = 'landing-reports/toggle-progress-bar';

const GET_BALANCES_SUCCESS = 'landing-reports/get-balances-success';
const GET_BALANCES_ERROR = 'landing-reports/get-balances-error';

const PREPARATION_FILE_SUCCESS = 'threads-item/preparation-file-success';

// permissions
export const allowedPermissions = {
	view: 'landing_reports_view'
};

// initial state
const initialState = {
	data: null,
	showProgressBar: false,
	mainForm: {
		fileToUpload: null
	},
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => dispatch => {
			setTimeout(() => dispatch({ type: FETCH_DATA_SUCCESS }), 1);
		},

		getReport: (reportName) => (dispatch, getState) => {
			const fileName = selectors.getPreparationFileName(getState());
			const data = selectors.getPreparationFile(getState());

			if (!data || !fileName) {
				return ;
			}

			return axios({
				url: endpoints.LANDING_REPORTS.BASE,
				method: 'POST',
				data,
				responseType: 'blob'
			}).then((response) => {
				dispatch(rootActions.spinnerToggle());

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				let filename = `${fileName.replace('.xlsx', '')}-data.xlsx`;

				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
			});
		},
		preparationFile: (file, nextAction) => dispatch => {
			const reader = new FileReader();
			const data = new FormData();

			data.append('file', file);

			reader.readAsDataURL(file);
			reader.onloadend = function () {
				nextAction(reader.result);
				dispatch({
					type: PREPARATION_FILE_SUCCESS,
					name: file.name,
					payload: data
				});
			};
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	}
);

// reducers
const reducers = Object.assign(
	{
		// placeholder data needed because of state machine and init func = fetchData
		[FETCH_DATA_SUCCESS]: (state, action) => ({ ...state, data: 'placeholder' }),
		[GET_BALANCES_SUCCESS]: (state, action) => ({ ...state, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[PREPARATION_FILE_SUCCESS]: (state, action) => ({
			...state,
			mainForm: {
				...state.mainForm, fileToUpload: action.payload, fileName: action.name
			}
		}),
		[GET_BALANCES_ERROR]: state => ({ ...state, error: true })
	}
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.landingReports.data,
	getPreparationFile: state => state.landingReports.mainForm.fileToUpload,
	getPreparationFileName: state => state.landingReports.mainForm.fileName,
	getIntl: state => intl(state),
	getProgressBar: state => state.landingReports.showProgressBar,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.landingReports.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/landing-reports/index.js